import * as types from 'store/mutation-types'
import {
  fetchActualExpiryOptionChain,
  fetchStockOptionChains
} from 'apis/option'
const state = {
  symbol: null,
  data: null,
  expires: [],
  expiry: null,
  defaultExpiry: null
}

const mutations = {
  [types.SAVE_OPTION_CHAIN](state, [symbol, data, expires, defaultExpiry]) {
    data.data = data.data.map(pair => {
      if (pair.length === 2) return pair
      const item = pair[0]
      const gen = {
        strike: pair[0].strike,
        _fake: true
      }

      if (item.right === 'put') {
        gen.right = 'call'
        return [gen, pair[0]]
      } else {
        gen.right = 'put'
        return [pair[0], gen]
      }
    })
    state.symbol = symbol
    state.data = {
      ...state.data,
      [data.expiry]: data.data
    }
    state.expiry = data.expiry
    if (expires) {
      state.expires = expires
    }
    if (defaultExpiry) {
      state.defaultExpiry = defaultExpiry
    }
  }
}

const actions = {
  // @param expiry is optional
  fetchOptionChain({ commit }, [symbol, expiry]) {
    if (expiry) {
      return fetchActualExpiryOptionChain({ symbol, expiry }).then(
        ({ data: resp }) => {
          return commit(types.SAVE_OPTION_CHAIN, [
            symbol,
            {
              data: resp.data,
              expiry
            },
            null,
            null
          ])
        }
      )
    } else {
      return fetchStockOptionChains(symbol).then(({ data: resp }) => {
        return commit(types.SAVE_OPTION_CHAIN, [
          symbol,
          {
            data: (resp.default && resp.default.data) || [],
            expiry: resp.default && resp.default.expiry
          },
          resp.expires || [],
          resp.default && resp.default.expiry
        ])
      })
    }
  }
}

export default {
  state,
  mutations,
  actions
}
